export default __webpack_public_path__ + "static/media/airtel.db9f8cf8.svg";